import { getAdditionalUserInfo, GoogleAuthProvider, sendEmailVerification, signInWithEmailAndPassword, signInWithPopup, signOut } from 'firebase/auth';
import { CustomInput } from '../../components/input/CustomInput';
import * as St from './index.styled';
import firebaseAuth from '../../firebase/auth';
import { Link, useNavigate } from 'react-router-dom';
import { CustomRatioImage } from '../../components/image/CustomRatioImage';
import CustomBlockButton from '../../components/button/CustomBlockButton';
import { useState } from 'react';
import { CustomBackdropController } from '../../components/backdrop/default/v1/core';
import { customToast } from '../../components/toast/custom-react-toastify/v1';
import { UserAuthApi } from '@/apis/v2/UserAuthApi';
import { useAuthContextActionsHook, useAuthContextValueHook } from '@/contexts/AuthContext';
import { LegalLinks } from '../../components/legal/LegalLinks';

const customBackdropController = CustomBackdropController();
const PAGE_CLIENT_URL = process.env.REACT_APP_PAGE_CLIENT_URL;

export function MainView(props) {
    const navigate = useNavigate();

    const authContextActionsHook = useAuthContextActionsHook();
    const authContextValueHook = useAuthContextValueHook();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [reSendEmailVerificationModeOpen, setReSendEmailVerificationModeOpen] = useState(false);

    const handleChangeEmailFromEvent = (e) => {
        let value = e.target.value;

        setEmail(value);
    }

    const handleChangePasswordFromEvent = (e) => {
        let value = e.target.value;

        setPassword(value);
    }

    const handleLoginWithGoogle = async () => {
        const provider = new GoogleAuthProvider();

        customBackdropController.showBackdrop();
        const googleLoginResult = await signInWithPopup(firebaseAuth, provider)
            .then(data => {
                return data;
            })
            .catch(err => {
                console.log(err);
                return null;
            })
            .finally(() => {
                customBackdropController.hideBackdrop();
            })

        const firebaseAccessToken = googleLoginResult?.user?.accessToken;
        if (firebaseAccessToken) {

            const body = {
                payload: {
                    firebaseAccessToken: firebaseAccessToken
                }
            }
            customBackdropController.showBackdrop();
            // 신규 회원이라면 데이터 동기화를 위해 3초 대기
            if (getAdditionalUserInfo(googleLoginResult)?.isNewUser) {
                await new Promise(resolve => setTimeout(resolve, 3000));
            }

            const loginResult = await UserAuthApi.LoginWithGoogleFirebase({ body: body, })
                .then(res => {
                    return res?.data?.data;
                }).catch(err => {
                    customToast.error('구글 로그인에 실패했습니다. 잠시 후 다시 시도해 주세요.\n같은 문제가 지속적으로 발생 시 고객센터로 문의해 주세요.');
                    console.log(err);
                })

            if (loginResult?.accessToken) {
                authContextActionsHook.login(loginResult?.accessToken);
            }

            // navigate(`${PAGE_CLIENT_URL}`, { replace: true });
            window.location.replace(`${PAGE_CLIENT_URL}`);
        } else {
            customToast.error('구글 로그인에 실패했습니다. 잠시 후 다시 시도해 주세요.');
        }
        customBackdropController.hideBackdrop();
    }

    const handleLoginWithEmailAndPassword = async (e) => {
        e.preventDefault();
        if (!email) {
            customToast.error('이메일을 입력해 주세요.');
            return;
        }

        if (!password) {
            customToast.error('패스워드를 입력해 주세요.');
            return;
        }

        customBackdropController.showBackdrop();
        const googleLoginResult = await signInWithEmailAndPassword(firebaseAuth, email, password)
            .then(data => {
                if (data?.user?.emailVerified) {
                    return data;
                } else {
                    setReSendEmailVerificationModeOpen(true);
                    customToast.error(`이메일 인증을 완료해 주세요.`);
                    return null;
                }
            })
            .catch(err => {
                console.log(err);
                customToast.error(`아이디 또는 패스워드를 확인해 주세요.`);
                return null;
            })
            .finally(() => {
                customBackdropController.hideBackdrop();
            })

        const firebaseAccessToken = googleLoginResult?.user?.accessToken;
        if (firebaseAccessToken) {
            const body = {
                payload: {
                    firebaseAccessToken: firebaseAccessToken
                }
            }
            customBackdropController.showBackdrop();
            const loginResult = await UserAuthApi.LoginWithGoogleFirebase({ body: body, })
                .then(res => {
                    return res?.data?.data;
                }).catch(err => {
                    customToast.error('로그인에 실패했습니다. 잠시 후 다시 시도해 주세요.');
                    console.log(err);
                })

            if (loginResult?.accessToken) {
                authContextActionsHook.login(loginResult?.accessToken);
            }

            window.location.replace(`${PAGE_CLIENT_URL}`);
        }
        customBackdropController.hideBackdrop();
    }

    const handleReSendEmailVerification = async () => {
        customBackdropController.showBackdrop();
        await sendEmailVerification(firebaseAuth.currentUser)
            .then(res => {
                customToast.success(`인증 메일이 전송되었습니다.`);
            })
            .catch(err => {
                customToast.error(`인증 메일 전송에 실패했습니다. 잠시 후 다시 시도해 주세요.`);
            });
        customBackdropController.hideBackdrop();
    }

    const handleSignOut = () => {
        signOut(firebaseAuth);
    }

    return (
        <>
            <div className="min-h-screen bg-[#f5f5f7] px-3 pb-24 pt-8 sm:pt-16">
            <St.Container>
                <form onSubmit={(e) => handleLoginWithEmailAndPassword(e)}>
                    <St.Wrapper>
                        <St.LogoWrapper>
                            <Link to={PAGE_CLIENT_URL}>
                                <CustomRatioImage width={1} height={1}>
                                    <CustomRatioImage.Image src={'/assets/images/shooluk_logo.png'} />
                                </CustomRatioImage>
                            </Link>
                        </St.LogoWrapper>
                        <St.IntroduceWrapper>
                            <div className='mainDescription'>슈룩에 오신것을 환영합니다.</div>
                            <div className='subDescription'>여러가지 링크를 하나의 링크로 관리해 보세요.</div>
                        </St.IntroduceWrapper>
                        {!(authContextValueHook?.isLoggedIn && authContextValueHook?.isReady) &&
                            <>
                                <St.InputGroupWrapper>
                                    <CustomInput
                                        type='email'
                                        value={email || ''}
                                        onChange={(e) => handleChangeEmailFromEvent(e)}
                                        placeholder='이메일'
                                    />
                                    <CustomInput
                                        type='password'
                                        value={password || ''}
                                        onChange={(e) => handleChangePasswordFromEvent(e)}
                                        placeholder='비밀번호'
                                    />
                                    <div className='forgotWrapper'>
                                        <Link
                                            to='/find/user'
                                        >
                                            아이디 찾기
                                        </Link>
                                        <div>•</div>
                                        <Link
                                            to='/find/password'
                                        >비밀번호 찾기</Link>
                                    </div>
                                </St.InputGroupWrapper>
                                <St.LoginButtonGroup>
                                    <CustomBlockButton
                                        type='submit'
                                        className='login'
                                    >
                                        이메일 로그인
                                    </CustomBlockButton>
                                    {reSendEmailVerificationModeOpen &&
                                        <CustomBlockButton
                                            type='button'
                                            className='reSendEmailVerification'
                                            onClick={() => handleReSendEmailVerification()}
                                        >
                                            인증 메일 재전송
                                        </CustomBlockButton>
                                    }
                                </St.LoginButtonGroup>
                                <St.LineBreaker>or</St.LineBreaker>
                                <St.SnsLoginButtonGroup>
                                    <CustomBlockButton type='button' onClick={() => handleLoginWithGoogle()}>
                                        <div className='content'>
                                            <div className='logoIcon'>
                                                <CustomRatioImage width={1} height={1}>
                                                    <CustomRatioImage.Image src={'/assets/icons/google_icon.svg'} />
                                                </CustomRatioImage>
                                            </div>
                                            <div>Google 계정으로 로그인</div>
                                        </div>
                                    </CustomBlockButton>
                                </St.SnsLoginButtonGroup>
                                <p className="mt-3 text-center text-[12px] leading-snug text-gray-500">Google 계정으로 처음 로그인하면 <LegalLinks />에 동의하고 가입하는 것으로 봅니다.</p>
                                <St.FooterFieldWrapper>
                                    <div className='text'>아직 슈룩의 회원이 아니신가요?</div>
                                    <div>
                                        <Link
                                            to='/signup'
                                        >
                                            <CustomBlockButton
                                                type='button'
                                                className='button'
                                            >
                                                무료 회원가입
                                            </CustomBlockButton>
                                        </Link>
                                    </div>
                                </St.FooterFieldWrapper>
                            </>
                        }

                        {(authContextValueHook?.isLoggedIn && authContextValueHook?.isReady) &&
                            <>
                                <St.LoginButtonGroup>
                                    <CustomBlockButton type='button' onClick={() => handleSignOut()}>로그아웃</CustomBlockButton>
                                </St.LoginButtonGroup>

                            </>
                        }
                    </St.Wrapper>
                </form>
            </St.Container>
            </div>
        </>
    );
}